"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationActionType = void 0;
var NotificationActionType;
(function (NotificationActionType) {
    NotificationActionType["Acknowledge"] = "Acknowledge";
    NotificationActionType["Expired"] = "Expired";
})(NotificationActionType = exports.NotificationActionType || (exports.NotificationActionType = {}));
